import React, { Component } from 'react';
import '../../../resources/AdminStandardPage.css';
import AuthenticationService from '../../../services/AuthenticationService';
import DeletePUGCertificates from '../../../components/Dialogs/DeleteDialog/DeleteDialog';
import AttachmentField from '../../../components/AttachmentField/AttachmentField';
import NotificationSystem from 'react-notification-system';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import { financialSituationService } from '../../../services/FinancialSituationService';
import ReactPaginate from 'react-paginate';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import { getArchiveYears } from '../../../services/ArchiveYearsService';

class AdminFinancialSituation extends Component {
  constructor(props) {
    super(props);
    const archiveYears = getArchiveYears();

    this.state = {
      disabledDocument: false,
      newFinancialSituation: {
        title: '',
        document: '',
        date:''
      },
      existingFinancialSituations: [],
      searchFinancialSituation: {
        title: '',
        archiveYear:
          archiveYears && archiveYears.length > 0
            ? archiveYears[0].value
            : new Date().getFullYear().toString()
      },
      archiveYears,
      deleteFinancialSituation: {
        openedDialog: false,
        deleteId: 0
      },
      pagination: {}
    };

    this.authentication = new AuthenticationService();
  }

  componentWillMount() {
    this.search();
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  handlePageClick = selectedPage => {
    this.search(selectedPage.selected + 1);
  };

  setFinanctialSituationState = response => {
    let existingFinancialSituations = {
      ...this.state.existingFinancialSituations
    };
    let pagination = { ...this.state.pagination };
    existingFinancialSituations = response.financial_situations;
    pagination = response.pagination;

    this.setState({ existingFinancialSituations });
    this.setState({ pagination });
  };

  updateField = event => {
    const field = event.target.name;
    const newFinancialSituation = this.state.newFinancialSituation;
    newFinancialSituation[field] = event.target.value;

    this.setState({
      newFinancialSituation
    });
  };

  updateSearchField = event => {
    const field = event.target.name;
    const searchFinancialSituation = { ...this.state.searchFinancialSituation };
    searchFinancialSituation[field] = event.target.value;

    this.setState(
      {
        searchFinancialSituation
      },
      () => {
        if (field === 'archiveYear') {
          this.search();
        }
      }
    );
  };

  search = (pageNumber = 1) => {
    financialSituationService
      .search(this.state.searchFinancialSituation, pageNumber)
      .then(jsonResponse => {
        this.setFinanctialSituationState(jsonResponse);
      })
      .catch(error => console.log(error));
  };

  onDropDocument = documents => {
    let newFinancialSituation = { ...this.state.newFinancialSituation };
    let reader = new FileReader();
    let self = this;

    reader.onload = function(upload) {
      newFinancialSituation.document = documents[0];

      self.setState({ newFinancialSituation });
      self.setState({ disabledDocument: true });
    };
    reader.readAsDataURL(documents[0]);
  };

  removeDocument = () => {
    let newFinancialSituation = { ...this.state.newFinancialSituation };
    newFinancialSituation.document = null;

    this.setState({ newFinancialSituation });
    this.setState({ disabledDocument: false });
  };

  resetForm = () => {
    let newFinancialSituation = { ...this.state.newFinancialSituation };
    newFinancialSituation = {
      title: '',
      document: ''
    };

    this.setState({ newFinancialSituation });
    this.setState({ disabledDocument: false });
  };

  handleFormSubmit = event => {
    event.preventDefault();
    const currentId = this.state.newFinancialSituation.id;

    const headers = {
      Accept: 'application/json'
    };

    if (this.authentication.loggedIn()) {
      headers['Authorization'] = 'Bearer ' + this.authentication.getToken();
    }

    let url = `${process.env.REACT_APP_API_URL}/api/financial_situations/`;
    let callMethod = 'POST';

    if (currentId) {
      url = `${process.env.REACT_APP_API_URL}/api/financial_situations/${this.state.newFinancialSituation.id}`;
      callMethod = 'PUT';
    }

    const formattedData = this.buildFormData();

    fetch(url, {
      method: callMethod,
      body: formattedData,
      headers
    })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(jsonResponse => {
        this.resetForm();
        this.search();

        if (currentId) {
          this._notificationSystem.addNotification({
            message: 'Situatia a fost editata cu success.',
            level: 'success',
            position: 'tc'
          });
        } else {
          this._notificationSystem.addNotification({
            message: 'Situatia a fost adaugata cu success.',
            level: 'success',
            position: 'tc'
          });
        }
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  buildFormData() {
    let formData = new FormData();
    formData.append(
      'financial_situation[title]',
      this.state.newFinancialSituation.title
    );
    formData.append(
      'financial_situation[add_date]',
      this.state.newFinancialSituation.date
    );

    if (this.state.newFinancialSituation.document) {
      let document = this.state.newFinancialSituation.document;
      formData.append(`financial_situation[document]`, document, document.name);
    }

    return formData;
  }

  setConvocationAgendaForEdit = newFinancialSituationDoc => {
    let newFinancialSituation = { ...this.state.newFinancialSituation };
    newFinancialSituation = Object.assign({}, newFinancialSituationDoc);
    this.setState({ newFinancialSituation });

    if (newFinancialSituation.document.url) {
      this.setState({ disabledDocument: true });
    }
  };

  openDeleteDialog = id => {
    let deleteFinancialSituation = { ...this.state.deleteFinancialSituation };
    deleteFinancialSituation = {
      openedDialog: true,
      deleteId: id
    };

    this.setState({ deleteFinancialSituation });
  };

  closeDeleteDialog = () => {
    let deleteFinancialSituation = { ...this.state.deleteFinancialSituation };
    deleteFinancialSituation = {
      openedDialog: false,
      deleteId: 0
    };

    this.setState({ deleteFinancialSituation });
  };

  handleDelete = () => {
    financialSituationService
      .deleteFinancialSituation(this.state.deleteFinancialSituation.deleteId)
      .then(() => {
        this.closeDeleteDialog();
        this.search();

        this._notificationSystem.addNotification({
          message: 'Situatia a fost stearsa cu success.',
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  handleErrors = response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  };

  render() {
    return (
      <div className="admin-standard-page">
        <div className="admin-standard-page__title">
          <h3 className="admin-page__profile-title profile-title-specific">
            Financiar
          </h3>
          <h1 className="admin-switch-title default-title">
            Situatie Financiara
          </h1>
        </div>
        <div className="title-line" />
        <div className="admin-standard-page__content">
          <div className="admin-standard-page__create-project">
            <div className="card">
              <form className="admin-form" onSubmit={this.handleFormSubmit}>
                <h2 className="admin-form__title">
                  Adauga o situatie financiara noua
                </h2>

                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">
                    Titlu situatie financiara*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="text"
                    name="title"
                    onChange={this.updateField}
                    value={this.state.newFinancialSituation.title}
                  />
                </div>
                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">
                    Data*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="date"
                    name="date"
                    onChange={this.updateField}
                    value={this.state.newFinancialSituation.date}
                  />
                </div>
                <div className="admin-form__upload">
                  <h4 className="label-title label-title-provisions">
                    Document situatie financiara:
                  </h4>
                  <AttachmentField
                    onDrop={this.onDropDocument}
                    removeDocument={this.removeDocument}
                    disabledDocuments={this.state.disabledDocument}
                    document={this.state.newFinancialSituation.document}
                    documentFilename={
                      this.state.newFinancialSituation.document_filename
                    }
                    type="application/pdf"
                  />
                </div>
                <div className="form-buttons">
                  <div className="admin-form__submit">
                    <button
                      type="submit"
                      className="submit-button general-button"
                    >
                      {this.state.newFinancialSituation.id
                        ? 'Editează situatie financiara'
                        : 'Adaugă situatie financiara'}
                    </button>
                  </div>
                  {Object.values(this.state.newFinancialSituation) && (
                    <button
                      type="button"
                      className="general-button reset-button"
                      onClick={() => this.resetForm()}
                    >
                      Resetează câmpurile
                    </button>
                  )}
                </div>
              </form>
              <div className="admin-form__field admin-year-filter admin-year-filter--documents">
                <h4 className="label-title label-title-provisions">
                  Afiseaza documente pentru anul:
                </h4>
                <FormControl className="admin-year-filter__control">
                  <NativeSelect
                    className="admin-year-filter__select"
                    value={this.state.searchFinancialSituation.archiveYear}
                    onChange={this.updateSearchField}
                    inputProps={{
                      name: 'archiveYear'
                    }}
                  >
                    {this.state.archiveYears.map(archive => (
                      <option value={archive.value}>{archive.name}</option>
                    ))}
                  </NativeSelect>
                </FormControl>
              </div>
            </div>
          </div>
          {this.state.existingFinancialSituations.length > 0 && (
            <div className="admin-standard-page__existing-items">
              <div className="card">
                <div className="existing-items">
                  <h2 className="existing-items__title label-title">
                    Situatii financiare existente
                  </h2>
                  <div className="existing-items__content">
                    {this.state.existingFinancialSituations.map(
                      financialSituation => (
                        <div
                          className="existing-items__content-card"
                          key={financialSituation.id}
                        >
                          <div className="card-content provisions-title-content">
                            <h3 className="major-provisions-title">
                              {financialSituation.title}
                            </h3>
                          </div>
                          <div className="existing-items__actions-card">
                            <div
                              className="provisions-title-content"
                              onClick={() =>
                                this.setConvocationAgendaForEdit(
                                  financialSituation
                                )
                              }
                            >
                              <h4 className="action-title"> Editează</h4>
                            </div>

                            <div
                              className="provisions-title-content"
                              onClick={() =>
                                this.openDeleteDialog(financialSituation.id)
                              }
                            >
                              <h4 className="action-title delete-button">
                                {' '}
                                Șterge
                              </h4>
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                  <DeletePUGCertificates
                    opened={this.state.deleteFinancialSituation.openedDialog}
                    handleClose={this.closeDeleteDialog}
                    handleDelete={this.handleDelete}
                    headline="Sunteti sigur ca doriti sa stergeti acest document?"
                    aditionalText="Dupa stergere, documentul nu va mai putea fi recuperat."
                  />
                </div>
                {this.state.pagination.last_page > 1 && (
                  <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pagination.last_page}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        <NotificationSystem
          ref="notificationSystem"
          style={NotificationSystemStyle}
        />
      </div>
    );
  }
}

export default AdminFinancialSituation;
